<template>
  <div class="login-page">
    <TopBarUnLogin />
    <LoginPage />
    <FooterBarWhite />
  </div>
</template>

<script>
import TopBarUnLogin from '@/components/TopBarUnLogin.vue'
import LoginPage from '@/components/LoginPage.vue'
import FooterBarWhite from '@/components/FooterBar/FooterBarWhite.vue'

export default {
  name: 'Login',
  components: {
    TopBarUnLogin,
    LoginPage,
    FooterBarWhite
  }
}
</script>